import { call, put, take, takeLatest } from 'redux-saga/effects';
import axios from 'axios';
import { REQUEST, fetchSuccess, fetchFailure } from '../../actions/workspaces/memberAdd';
import {
  fetchRequest as fetchMembers,
  RESPONSE as MEMBERS_RESPONSE,
  FAILURE as MEMBERS_FAILURE,
} from '../../actions/workspaces/members';
import config from '../../../config';
import { getLocalUser } from '../../../utils/localUser';
import { Error as ErrorAction } from '../../actions/error/error';

function* operation(action) {
  const { workspaceId, userId, role } = action.payload;
  try {
    yield call(
      axios.post,
      `${config.API_URL}/workspace/${workspaceId}/members`,
      { user_id: userId, role },
      { headers: getLocalUser() },
    );
    yield put({ type: 'SHOW_SUCCESS_SNACKBAR', message: 'Member added' });
    // Keep the "Adding…" state until the member list refresh lands, like
    // the old "await loadMembers()".
    yield put(fetchMembers({ workspaceId }));
    yield take([MEMBERS_RESPONSE, MEMBERS_FAILURE]);
    yield put(fetchSuccess({ userId }));
  } catch (err) {
    yield put(ErrorAction(err));
    const message = err?.response?.data?.message || 'Could not add member';
    yield put({ type: 'SHOW_ERROR_SNACKBAR', message });
    yield put(fetchFailure(message));
  }
}

export function* watch() {
  yield takeLatest(REQUEST, operation);
}
